exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckboxVcDemo .checkItem[data-v-3070a6d8]{margin-right:15px}.CheckboxVcDemo .checkItem .demoLabel[data-v-3070a6d8]{margin-right:10px}.CheckboxVcDemo p[data-v-3070a6d8]{color:#066}.CheckboxVcDemo .demoText[data-v-3070a6d8]{margin:15px 10px 5px}", ""]);

// exports
